import { Yup, TRANSLATION, moment } from '@/imports-files/components/model/custom-company-integration-modal';


export const CONSTANTS = {
                                    texts: {
                                          heading: 'Setup Video Q & A',
                                          subheading1: 'Select a language, add an introduction video, setup questions among other things to send a Video Q&A to your candidate',
                                          subheading2: 'Interview Question',
                                          label1: 'Language',
                                          label2: 'Intro Video',
                                          label3: 'Question',
                                          label4: 'Description',
                                          label5: 'Time to Answer',
                                          label6: 'Sec',
                                          label7: 'No. of attempts',
                                          label8: 'Max. 3 attempts',
                                          placeholder_intro_video:'https://www.heartpace.com',
                                          placeholder_question: 'Why do you want to work for our business?',
                                          placeholder_descripton: 'Description for the question',
                                          add_question : 'Add Question',
                                          customisations: 'Customisations',
                                          practice_screen: 'Practice Screen',
                                          optional: 'Optional',
                                          automation: 'Automation',
                                          expires: 'Expires',
                                          review_email: 'Review Email',
                                          save: 'Save'
                              },
                              errors:{
                                          minimum: 'Minimum $number',
                                          maximum: 'Maximum $number'
                                    }
                        }

export const SETUP_VIDEO_QA_INITIAL_VALUES =  {
                                                language: 'English',
                                                video_link: '',
                                                questions_attributes: [{question: '', description: '', attempts: 2, answer_time: 30, _destroy: false}],
                                                job_stage_attributes: {automation: false},
                                                practise_screen: false,
                                                expires: ''
                                              }

export const SETUP_VIDEO_QA_SCHEMA =   Yup.object({
                                language: Yup.string().required(TRANSLATION('errors:required')),
                                video_link: Yup.string().matches(/^(http|https):\/\/|[a-z0-9]+([\-\.]{1}[a-z0-9]+)*\.[a-z]{2,6}(:[0-9]{1,5})?(\/.*)?$/mg, TRANSLATION('errors:invalid_url')).nullable(true),
                                questions_attributes: Yup.array(
                                                       Yup.object().shape({
                                                       question: Yup.string().required(TRANSLATION('errors:required')),
                                                      answer_time: Yup.number().required(TRANSLATION('errors:required')).min(30,CONSTANTS.errors.minimum.replace('$number', 30)).max(120, CONSTANTS.errors.maximum.replace('$number', 120)).nullable(true),
                                                      attempts: Yup.number().required(TRANSLATION('errors:required')).min(1, CONSTANTS.errors.minimum.replace('$number', 1)).max(3, CONSTANTS.errors.maximum.replace('$number', 3)).nullable(true)
                                                  })),
                                expires: Yup.number().required(TRANSLATION('errors:required')),
                          })
